export default "__VITE_ASSET__BN9iC8Os__ 640w, __VITE_ASSET__CpkIbTdX__ 1024w";